module.exports = __webpack_public_path__ + "static/media/pinwheel.2af4f6a1.svg";